<gc-accordion class="self-inspection-section" [expanded]="true">
  <ng-template #gcAccordionHeader>
    <div class="accordion-header">
      <gc-icon
        [iconName]="
          completedCount() === items().length && items().length > 0
            ? 'circleCheck'
            : 'circleClose'
        "
        [color]="
          completedCount() === items().length && items().length > 0
            ? 'success'
            : 'primary'
        "
      />
      <gc-text [variant]="'paragraphBold'">
        {{ sectionTitleKey() | translate }} ({{ completedCount() }}/{{
          items().length
        }})
      </gc-text>
    </div>
  </ng-template>
  <ng-template #gcAccordionBody>
    <div class="accordion-body">
      <div class="toggle-row">
        <gc-toggle
          [value]="state().showControlled"
          [label]="
            'installationReportV2.selfInspection.showControlled' | translate
          "
          (toggled)="toggleShowControlled.emit($event)"
        />
      </div>
      @for (item of visibleItems(); track item.id) {
        <app-self-inspection-item
          [item]="item"
          [answer]="itemAnswer(item.id)"
          [completed]="itemAnswer(item.id).completed"
          [loading]="mutationLoadingState()[item.id] ?? false"
          (markDone)="markDone.emit(item.id)"
          (markNotApplicable)="
            markNotApplicable.emit({ itemId: item.id, comment: $event })
          "
          (uploadFiles)="uploadFiles.emit({ itemId: item.id, files: $event })"
          (undo)="undo.emit(item.id)"
          (viewAttachments)="viewAttachments.emit($event)"
        />
      }
    </div>
  </ng-template>
</gc-accordion>
